import { createFileRoute } from "@tanstack/react-router"
import { BriefsPage } from "@/brief"

export const Route = createFileRoute("/(user)/t/$tenantSlug/briefs")({
  validateSearch: (search): { includeArchived?: boolean } => ({
    // Only present in the URL when on, so the default stays clean
    includeArchived: search.includeArchived === true ? true : undefined,
  }),
  component: RouteComponent,
})

function RouteComponent() {
  const { includeArchived } = Route.useSearch()
  const navigate = Route.useNavigate()

  return (
    <BriefsPage
      includeArchived={includeArchived ?? false}
      onIncludeArchivedChange={(value) => {
        void navigate({
          search: (prev) => ({ ...prev, includeArchived: value || undefined }),
        })
      }}
    />
  )
}
